import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useCallback, useState } from 'react';
import BiOption from '@wix/da-bi/pkg/Components/BiOption';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { isDropdownGroup, findSelectedItem } from '../helpers';
import { useDropdownItems } from '../hooks/useDropdownItems';
import { useDeepEqualMemo } from '@wix/da-hooks/pkg/useDeepEqualMemo';
const DUMMY_OPTION = {
    selected: true,
    disabled: true,
    hidden: true,
    value: 'null',
    label: ''
};
const NativeDropdown = (_param)=>{
    var { items, onSelect, onClick, biData, openBiData = biData, closeBiData = biData, value } = _param, rest = _object_without_properties(_param, [
        "items",
        "onSelect",
        "onClick",
        "biData",
        "openBiData",
        "closeBiData",
        "value"
    ]);
    const { filteredItems } = useDropdownItems(items);
    const selectedItem = findSelectedItem(filteredItems);
    const [isOpen, setOpen] = useState(false);
    const logBiEvent = useBiLogger();
    const memoizedBiData = useDeepEqualMemo(isOpen ? closeBiData : openBiData);
    const onClickWithBi = useCallback((event)=>{
        memoizedBiData && logBiEvent(memoizedBiData);
        setOpen((open)=>!open);
        onClick && onClick(event);
    }, [
        memoizedBiData,
        logBiEvent,
        onClick
    ]);
    const renderOption = ({ value: v, label, hidden, disabled, biData: optionBiData })=>/*#__PURE__*/ React.createElement(BiOption, {
            key: v,
            hidden: hidden,
            value: v,
            disabled: disabled,
            biData: optionBiData,
            label: label
        }, label, ' ');
    const renderOptGroup = ({ label, disabled, items: groupItems })=>/*#__PURE__*/ React.createElement("optgroup", {
            key: label,
            label: label,
            disabled: disabled
        }, groupItems.map(renderOption));
    return /*#__PURE__*/ React.createElement("select", _object_spread({
        onChange: (e)=>onSelect(e.target.value, e),
        onClick: onClickWithBi,
        value: value !== null && value !== void 0 ? value : selectedItem ? selectedItem.value : DUMMY_OPTION.value
    }, rest), !selectedItem && renderOption(DUMMY_OPTION), filteredItems.map((item)=>isDropdownGroup(item) ? renderOptGroup(item) : renderOption(item)));
};
NativeDropdown.displayName = 'NativeDropdown';
export default NativeDropdown;
